import {Fragment, useState} from "react"
import {PaymentArrangementSetup} from "@indebted/api/paymentArrangement/setup"
import {Box, Collapse, Divider, Grid, IconButton, Typography} from "@mui/material"
import {styled} from "@mui/material/styles"
import {useTranslation} from "react-i18next"
import {ChevronUpIcon, ChevronDownIcon} from "@indebted/assets"

import {formatCurrency} from "../../../src/currencyFormatter"
import {formatDate} from "../../../src/dateFormatter"
import {PanelDivider} from "../../components/Panel"
import {ValidLocale} from "../../../src/Locales"

export function PaymentSchedule({setupPage}: {setupPage: PaymentArrangementSetup}) {
	const [showSchedule, setShowSchedule] = useState(true)
	const {t, i18n} = useTranslation()
	return (
		<>
			<Box display="flex" alignItems="center" justifyContent="space-between">
				<PaymentsSchedule variant="subtitle1">
					{t("payment_arrangement_setup_page.scheduled_payments_details")}
				</PaymentsSchedule>
				<IconButton
					aria-label="toggle repayment schedule"
					size="small"
					onClick={() => setShowSchedule((prev) => !prev)}
					sx={{ml: 1}}
				>
					{showSchedule ? <ChevronDownIcon /> : <ChevronUpIcon />}
				</IconButton>
			</Box>
			{showSchedule ? <TopDivider /> : null}
			<Collapse in={showSchedule} timeout="auto" unmountOnExit>
				<Box>
					<Grid container columns={12}>
						<GridHeader size={4}>
							{t("payment_arrangement_setup_page.payment_details.headers.payment_number")}
						</GridHeader>
						<GridHeader size={4}>
							{t("payment_arrangement_setup_page.payment_details.headers.payment_date")}
						</GridHeader>
						<GridHeader size={4} sx={{textAlign: "end"}}>
							{t("payment_arrangement_setup_page.payment_details.headers.amount")}
						</GridHeader>
						<Grid size={12}>
							<Divider sx={{borderColor: "#f6f6f6"}} />
						</Grid>
						{setupPage.Payments.map((value, index) => (
							<Fragment key={index}>
								<GridPaymentItem size={4}>{index + 1}</GridPaymentItem>
								<GridDateItem size={4}>{formatDate(new Date(value.PaymentDate))}</GridDateItem>
								<GridAmountItem size={4}>
									{formatCurrency(
										value.PaymentAmount / 100,
										setupPage.Currency,
										i18n.language as ValidLocale,
									)}
								</GridAmountItem>
								<Grid size={12}>
									<Divider sx={{borderColor: "#f6f6f6"}} />
								</Grid>
							</Fragment>
						))}
					</Grid>
				</Box>
			</Collapse>
		</>
	)
}

const TopDivider = styled(PanelDivider)`
	margin-bottom: 0rem;
`

const PaymentsSchedule = styled(Typography)`
	color: #000244;
	font-size: 1.25rem;
	font-weight: 700;
	line-height: 1.25rem;
`

const GridHeader = styled(Grid)`
	color: #6b7280;
	font-size: 0.8125rem;
	font-weight: 500;
	line-height: 1rem;
	padding: 0.62rem 0 0.62rem;
`

const GridItem = styled(Grid)`
	padding: 0.64rem 0 0.67rem;
`

const GridPaymentItem = styled(GridItem)`
	color: #000244;
	font-size: 0.8125rem;
	font-weight: 500;
	line-height: 1rem;
`

const GridDateItem = styled(GridItem)`
	color: #000244;
	font-size: 0.8125rem;
	font-weight: 400;
	line-height: 1rem;
`

const GridAmountItem = styled(GridItem)`
	color: #000244;
	text-align: end;
	font-size: 0.8125rem;
	font-weight: 600;
	line-height: 1rem;
`
